// extracted by mini-css-extract-plugin
module.exports = {"formContent":"credit_check_form_formContent__LTlnL","popup":"credit_check_form_popup__K6igd"};